import type { ImageCard } from "../schema";

export interface Props extends ImageCard {
  className?: string;
  imageClassName?: string;
}

const IconCard = ({ alt, description, src, title, className = "", imageClassName }: Props) => {
  return (
    <div
      className={`grid grid-rows-auto-3 grid-cols-3 aspect-[5/6] relative px-5 bg-black w-full ${className}`}
    >
      <div className="grid-cols-1 grid items-center col-span-3 pl-6 md:pl-3 2xl:p-5 pt-2 pb-4 lg:pt-8">
        <img
          src={src}
          alt={alt}
          width={80}
          height={80}
          className={`object-fit col-start-1 row-start-1 ${imageClassName}`}
        />
      </div>
      <div className="w-full p-6 md:p-3 2xl:p-5 xl:h-24 col-span-3 self-start">
        <h1
          className={`font-condensedBoldItalic text-xl md:text-2xl lg:text-lg 2xl:text-2xl 3xl:text-2xl sm:max-h-12 md:min-h-16 xl:min-h-auto text-white`}
        >
          {title}
        </h1>
      </div>
      <div
        className={`flex-1 text-white text-sm md:text-lg lg:text-sm xl:text-base col-span-3 w-full px-6 md:px-3 2xl:px-5 pt-6 md:pt-3 2xl:pt-5 pb-8`}
      >
        <p className="font-Light w-full sm:min-h-36 sm:max-h-36 lg:min-h-44 lg:max-h-44 xl:min-h-72 2xl:min-h-60 3xl:min-h-44 xl:max-h-72">
          {description}
        </p>
      </div>
      <span className={`w-[1px] scale-x-50 col-start-1 absolute min-h-full block bg-white`}></span>
      <span
        className={`w-[1px] scale-x-50 absolute row-start-2 !col-start-4 h-full block bg-white`}
      ></span>
      <span
        className={`h-[1px] scale-y-50 absolute row-start-2 min-w-full block col-start-1  bg-white`}
      ></span>
      <span
        className={`h-[1px] scale-y-50 absolute row-start-3 min-w-full block col-end-4 bg-white`}
      ></span>
    </div>
  );
};

export default IconCard;
